export const article = Object.freeze({
	template: Object.freeze({
		default: 'Standard',
		gallery: 'Gallery',
		standard: 'Standard',
		sponsored: 'Sponsored',
		skimlinks: 'Skimlinks'
	})
})
